import { InjectionToken } from '@angular/core';

/**
 * Bridge to the AngularJS ConfigService used for app-level key/value settings.
 *
 * Reference: apps/b2b-ui/common/services/config/
 *
 * PermissionsService persists the RBAC checksum here under
 * `type='app'`, `name='rbacChecksum'`.
 */
export interface IConfigPort {
  get(type: string, name: string): unknown;
  set(props: { type: string; name: string; value: unknown }): void;
  clear(type: string, name: string, ...rest: unknown[]): void;
}

export const CONFIG_PORT = new InjectionToken<IConfigPort>('CONFIG_PORT');
